import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type SetMyWhatsNewEmailMutationVariables = Types.Exact<{
  input: Types.SetMyWhatsNewEmailInput;
}>;


export type SetMyWhatsNewEmailMutation = { __typename?: 'Mutation', setMyWhatsNewEmail: { __typename?: 'WhatsNewEmailRecipientPayload', recipient?: { __typename?: 'WhatsNewEmailRecipient', tenantId: string, email: string, subscribed: boolean } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };


export const SetMyWhatsNewEmailDocument = new TypedDocumentString(`
    mutation SetMyWhatsNewEmail($input: SetMyWhatsNewEmailInput!) {
  setMyWhatsNewEmail(input: $input) {
    recipient {
      ...WhatsNewEmailRecipient
    }
    errors {
      code
      message
    }
  }
}
    fragment WhatsNewEmailRecipient on WhatsNewEmailRecipient {
  tenantId
  email
  subscribed
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    SetMyWhatsNewEmail: build.mutation<SetMyWhatsNewEmailMutation, SetMyWhatsNewEmailMutationVariables>({
      query: (variables) => ({ document: SetMyWhatsNewEmailDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useSetMyWhatsNewEmailMutation } = injectedRtkApi;
